import { CHANNEL_MEDIA_PLAN_STATUS } from '@skyrise-eng/types';
import type { BaseColumn } from './MediaPlanList.types';

export const STATUS_CLASS = {
  [CHANNEL_MEDIA_PLAN_STATUS.DRAFT]: 'draft',
  [CHANNEL_MEDIA_PLAN_STATUS.READY]: 'ready',
  [CHANNEL_MEDIA_PLAN_STATUS.SENT]: 'sent'
};

export enum Column {
  DEAL_ID = 'dealId',
  CAMPAIGN = 'campaign',
  CLIENT = 'client',
  STATUS = 'status',
  MANAGER = 'manager',
  START_DATE = 'startDate',
  END_DATE = 'endDate',
  CHANNELS = 'channels',
  EXPECTED_MARGIN = 'expectedMargin',
  TOTAL_BUDGET = 'totalBudget',
  ACTIONS = 'actions'
}

/* Widths are the defaults; each column can be dragged wider or narrower
   (useResizableColumns), so they live here rather than as CSS limits. */
export const COLUMNS: Record<Column, BaseColumn> = {
  [Column.DEAL_ID]: {
    ellipsis: true,
    i18nKey: 'dealId',
    dataIndex: 'campaign',
    className: 'deal-id',
    key: 'dealId',
    width: 140,
    sorter: true
  },
  [Column.CAMPAIGN]: {
    ellipsis: true,
    i18nKey: 'campaign',
    dataIndex: 'campaign',
    className: 'campaign',
    key: 'campaign',
    width: 250,
    sorter: true
  },
  [Column.CLIENT]: {
    ellipsis: true,
    i18nKey: 'client',
    dataIndex: 'client',
    className: 'client',
    key: 'client',
    width: 150,
    sorter: true
  },
  [Column.STATUS]: {
    i18nKey: 'status',
    dataIndex: 'status',
    className: 'status',
    key: 'status',
    width: 100,
    sorter: true
  },
  [Column.MANAGER]: {
    ellipsis: true,
    i18nKey: 'responsibleAM',
    className: 'manager',
    dataIndex: 'manager',
    key: 'manager',
    width: 170
  },
  [Column.START_DATE]: {
    ellipsis: true,
    i18nKey: 'startDate',
    dataIndex: 'startDate',
    className: 'start-date',
    key: 'startDate',
    width: 150,
    sorter: true
  },
  [Column.END_DATE]: {
    ellipsis: true,
    i18nKey: 'endDate',
    dataIndex: 'endDate',
    className: 'end-date',
    key: 'endDate',
    width: 150,
    sorter: true
  },
  [Column.CHANNELS]: {
    ellipsis: true,
    i18nKey: 'channels',
    dataIndex: 'channel',
    className: 'channel',
    key: 'channel',
    width: 150
  },
  [Column.EXPECTED_MARGIN]: {
    ellipsis: true,
    i18nKey: 'expectedMargin',
    dataIndex: 'marginPercent',
    className: 'margin',
    key: 'expectedMargin',
    width: 150
  },
  [Column.TOTAL_BUDGET]: {
    ellipsis: true,
    i18nKey: 'totalBudget',
    dataIndex: 'totalBudget',
    className: 'total-budget',
    key: 'totalBudget',
    width: 150,
    align: 'right',
    sorter: true
  },
  [Column.ACTIONS]: {
    i18nKey: 'actions',
    dataIndex: 'actions',
    className: 'actions',
    key: 'actions',
    fixed: 'right',
    width: 170,
    align: 'center',
    ellipsis: true
  }
};
